export default function makeFactoryStatus(factory) {
  if (factory.approved_by) return 'Approved';
  if (factory.rejection_reason) return 'Rejected';
  return 'Pending Review';
}
